import { Component, OnInit, Input } from '@angular/core';
import { Validators, FormBuilder, FormArray, FormGroup, FormControl } from '@angular/forms';
import { FlashMessagesService } from 'angular2-flash-messages';
import { saveAs } from 'file-saver';

import { CommonService } from '../../../../common/service/common.service';
import { LimitFlowProposalService } from '../../../service/limit-flow-proposal/limit-flow-proposal.service';

@Component({
	selector: 'app-financial-demos',
	templateUrl: './financial-demos.component.html',
	styleUrls: ['./financial-demos.component.scss'],
	providers: [
		LimitFlowProposalService,
		CommonService
	]
})
export class FinancialDemosComponent implements OnInit {

	@Input('proposalID') proposalID: string = "";
	@Input('proposalStatus') proposalStatus: string = "";
	@Input('isUserOwner') isUserOwner: boolean = false;

	revenueRural: FormGroup;
	private token;
	public states: any[] = [];
	public citys: any[] = [];
	allowedFileSize: number;
    allowedFiles: string = "";

	public dre: {
		BalancoAuditado: boolean,
		EmpresaAuditora: '',
		Ressalvas: boolean,
		DemonstrativoFinanceiroID: '',
		Rating: '',
		PotencialCredito: '',
		PotencialPatrimonial: '',
		PotencialReceita: ''
	};

	constructor(private fb: FormBuilder, private limitFlowProposalService: LimitFlowProposalService, private flashMessagesService: FlashMessagesService, private commonService: CommonService) {
	}

	ngOnInit() {
		console.log("Load Financial Demos Tab");
		this.token = localStorage.getItem('yara.token');

		this.dre = $("#dreObj").val() ? JSON.parse($("#dreObj").val().toString()) : [];
		
		if (this.dre.DemonstrativoFinanceiroID && this.dre.DemonstrativoFinanceiroID !== "00000000-0000-0000-0000-000000000000") {
			this.getFinancialDemosById(this.dre.DemonstrativoFinanceiroID);	
		}
	}

	setBalancoAuditado(value) {
		this.dre.BalancoAuditado = value;
		$("#dreObj").val(JSON.stringify(this.dre));
	}

	setEmpresaAuditora(value) {
		this.dre.EmpresaAuditora = value;
		$("#dreObj").val(JSON.stringify(this.dre));
	}

	setRessalvas(value) {
		this.dre.Ressalvas = value;
		$("#dreObj").val(JSON.stringify(this.dre));
	}

	getFinancialDemosById(id) {
		this.limitFlowProposalService.getFinancialDemosById(id).subscribe(result => {
			if (result.Success) {
				console.log(result.Result);
				$(".financial-demos-table").html(result.Result.Html);
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
			return false;
		});
	}

	// When selected a file get the file and store on Arquivo attachmentList[i]
    fileSelected() {
        var input: any = document.getElementById("fileDemos");
        var file = input.files[0];
        this.uploadAttachment(file);
    }

    //Fuction to upload the attachment, receive the index of attachmentList obj
    uploadAttachment(file) {
        if (file.size / (1024 * 1024) > this.allowedFileSize) {
            this.flashMessagesService.show("Erro: O arquivo é maior que o permitido: " + this.allowedFileSize + " Mb", { cssClass: 'alert-danger', timeout: 6000 });
        } else {
            var formData = new FormData();
			formData.append('Arquivo', file);
			formData.append('Tipo', 'PJ');

            this.limitFlowProposalService.insertFinancialDemos(formData).subscribe(result => {
                if (result.Success) {
                    this.flashMessagesService.show("Template enviado com sucesso!", { cssClass: 'alert-success', timeout: 6000 });
					this.getFinancialDemosById(result.Result.ID);
					this.dre.DemonstrativoFinanceiroID = result.Result.ID;
					this.dre.Rating = result.Result.Rating;
					this.dre.PotencialCredito = result.Result.PotencialCredito;
					this.dre.PotencialPatrimonial = result.Result.PotencialCredito;
					this.dre.PotencialReceita = result.Result.PotencialCredito;
					$("#dreObj").val(JSON.stringify(this.dre));
                } else {
					$("#fileDemos").val("");
                    this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
                }
            }, error => {
                console.log(error);
            });
        }
	}
	
	getDreFile() {		
		if (this.dre.DemonstrativoFinanceiroID != null)
		{
			this.limitFlowProposalService.getDreFile(this.dre.DemonstrativoFinanceiroID).subscribe(blob => {
				if (blob) {
					saveAs(blob, 'DemonstrativoFinanceiro' + "." + 'xls');
				} else {
					this.flashMessagesService.show("Problema ao baixar o arquivo", { cssClass: 'alert-danger', timeout: 6000 });
				}
			}, error => {
				console.log(error);
			});
		} else {
			this.flashMessagesService.show("Não existe nenhum arquivo disponível para download", { cssClass: 'alert-danger', timeout: 6000 });
		}
	}

	getDreModel() {
		let myFile = "/assets/files/rating_PJ_-_versao_28_12_17.xlsm";
		var a = document.createElement('a');
		a.href = myFile;
		a.download = myFile.substr(myFile.lastIndexOf('/') + 1);
		document.body.appendChild(a);
		a.click();
		document.body.removeChild(a);
	}
}





// WEBPACK FOOTER //
// ./src/app/limit-flow-proposal/component/limit-flow-proposal/financial-demos/financial-demos.component.ts